import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useUserStore = defineStore('user', () => {
  const userId = ref<number>()

  function setUserId(id: number): void {
    userId.value = id
  }

  return {
    userId,
    setUserId,
  }
})
